import React from "react";
import { Container } from "react-bootstrap";

function Footer() {
  return (
    <>
      <footer id="footer" className="footer minimal ">
        <Container className="py-4">
          <div className="d-flex justify-content-center">
            <div>
              <span className="footer-heding">
                Dogmatix can make mistakes. Check important info.
              </span>
            </div>
          </div>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
